import { exitImpersonationThunk } from 'actions/login/LoginActions';
import Button from 'components/UI/V3/Button/Button';
import { useImpersonation } from 'hooks';
import { FunctionComponent, useLayoutEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import styles from './ImpersonationBanner.module.scss';

// Fixed overlays positioned below the header add this to their top offset, so the banner doesn't hide them.
const BANNER_HEIGHT_VARIABLE = '--impersonation-banner-height';

export const ImpersonationBanner: FunctionComponent = () => {
    const dispatch = useDispatch();
    const impersonation = useImpersonation();
    const rootRef = useRef<HTMLDivElement>(null);

    useLayoutEffect(() => {
        const root = rootRef.current;

        if (!root) {
            return;
        }

        const rootStyle = document.documentElement.style;
        const resizeObserver = new ResizeObserver(() => {
            rootStyle.setProperty(BANNER_HEIGHT_VARIABLE, `${root.offsetHeight}px`);
        });

        resizeObserver.observe(root);

        return () => {
            resizeObserver.disconnect();
            rootStyle.removeProperty(BANNER_HEIGHT_VARIABLE);
        };
    }, [impersonation]);

    if (!impersonation) {
        return null;
    }

    const handleExit = () => {
        dispatch(exitImpersonationThunk());
    };

    return (
        <div
            ref={rootRef}
            className={styles.root}
            role="status"
        >
            <p className={styles.text}>
                You&apos;re logged in as{' '}
                <span className={styles.name}>
                    {impersonation.firstName} {impersonation.lastName}
                </span>
            </p>
            <Button
                label="Exit"
                size="small"
                variant="black"
                onClick={handleExit}
            />
        </div>
    );
};

export default ImpersonationBanner;
